import { preloadablePage, type PreloadablePage } from '@/lib/preloadablePage';

// The public pages served as prerendered snapshots (scripts/prerender.mjs). They load
// lazily like the rest of the app, but main.tsx can fetch the current one before the
// first render.
export const marketingPage = preloadablePage(() => import(/* webpackChunkName: "marketing" */'@/pages/MarketingLandingPage'));
export const industryPage = preloadablePage(() => import(/* webpackChunkName: "industry" */'@/pages/IndustryLandingPage'));
export const instantTasksPage = preloadablePage(() => import(/* webpackChunkName: "instantTasks" */'@/pages/InstantTasksLandingPage'));
export const termsPage = preloadablePage(() => import(/* webpackChunkName: "terms" */'@/pages/TermsPage'));
export const aboutPage = preloadablePage(() => import(/* webpackChunkName: "about" */'@/pages/AboutPage'));
export const privacyPage = preloadablePage(() => import(/* webpackChunkName: "privacy" */'@/pages/PrivacyPageV2'));
export const teamPage = preloadablePage(() => import(/* webpackChunkName: "team" */'@/pages/TeamPage'));

const MARKETING_PAGES: Record<string, PreloadablePage> = {
  '/': marketingPage,
  '/whatsapp-task-management': instantTasksPage,
  '/terms': termsPage,
  '/about': aboutPage,
  '/privacy': privacyPage,
  '/team': teamPage,
};

/** Fetches the code of the marketing page at pathname; null when it is not one. */
export function preloadMarketingPage(pathname: string): Promise<void> | null {
  const route = pathname.replace(/\/+$/, '') || '/';
  const page = route.startsWith('/industries/') ? industryPage : MARKETING_PAGES[route];
  return page ? page.preload() : null;
}
